import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider } from "formik";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const ChequeFollowUpEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
 
  const [backendErrors, setBackendErrors] = useState([]);
  const [permission, setPermission] = useState({});

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
   let season_id = localStorage.getItem("season_id");


  const formik = useFormik({
    initialValues: {
      season_id:season_id,
      id: value.id,
      bank_name: value.bank_name,
      date: value.date,
      amount: value.amount,
      cheque_number:value.cheque_number,
      cheque_status:value.cheque_status,
      cheque_collection_date:value.cheque_collection_date,
      cheque_designation:value.cheque_designation,
      expense_type:value.expense_type,
    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values , { setSubmitting }) => {
      axios
        .post("/cheque-followup/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
         
          delete backendErrors['error'];
          setSubmitting(false);
          // actions.setSubmitting(false);
          $("#form-submit").text("Update Cheque FollowUp");
           if (response.data.code === 200) {
            
             toast.success(response.data.message);
          //   actions.resetForm();
             setTimeout(() => {
               window.location.href = "/cheque-follow-ups";
             }, 1000);
           }  else if (response.data.code === 422) {
               setBackendErrors(response.data.error);
           }
           else if (response.data.code === 401) {
             setBackendErrors(response.data.error);
           }
           else {
              setBackendErrors(response.data.error);
           }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
        setPermission(FindModuleById(371)); 
console.log(permission);

    axios
      .get(`/cheque-followup/edit/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
         setValue(response.data.data.cheque);
         
        }
      })
      .catch((error) => {
        console.log(error);
      });
    
  }, [id]);


  useEffect(() => {

   
  

}, []);
const customHandleCollection = (event) => {
  const valuu = event.value;
  if(valuu ==1){
    $(".check-collection-date-section").show();
  }else{
    $(".check-collection-date-section").hide();
    
  }

};
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const statusOptions = ([
 
    { value: 1, label: "Collected" },
    { value: 0, label: "Not Collected" },
  ]);
  const extypes = ([
 
    { value: 1, label: "Frais Divers" },
    { value: 2, label: "Don" },    
    { value: 3, label: "Matiere premiere" },
    
  ]);
  const bankslist = ([
 
    { value: 1, label: "BMCE EO" },
    { value: 2, label: "Credit Agricole EO" },
  ]);
  
const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Cheque FollowUp</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/cheque-follow-ups">Cheque FollowUp</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Cheque FollowUp Info</h4>
                    <FormikProvider value={formik}>
                      {permission && permission.update == 1 && ( 
                         <form onSubmit={formik.handleSubmit}>
                     
                      <div className="row">

                                                  
                        <div className="col-md-6">
                        <div className="form-group">
                              <label>Bank Name</label>
                              <Select
                              className="w-100"
                              value={bankslist.find(option => option.value == formik.values.bank_name) || null} // Ensure correct format
                              name="bank_name"
                              //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                              onChange={(selectedOption) => {
                                handleSelectChange("bank_name", selectedOption);
                                // customfunction(selectedOption);
                              }}
                              onBlur={formik.handleBlur}
                              options={bankslist}
                              placeholder="Select" 
                                  // value={formik.values.bank_name}
                                  // name="bank_name"
                                  // data={bankslist}
                                  // className= "w-100"
                                  // onChange={(e) => {
                                  //   formik.handleChange(e);
                                  //   customHandleInput(e);
                                  // }}
                                  //   onBlur={formik.handleBlur}
                                  // options={{
                                  //   placeholder: "Select Bank",
                                  // }}
                                />
                              <small>
                                {backendErrors.bank_name && (
                                    <span className="form-error mt-1">
                                      {backendErrors.bank_name}
                                    </span>
                                  )}
                              </small>
                            </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                              <label>Check Number</label>
                              
                              <div className="input-group">
                                  <input type="text" 
                                  name="cheque_number"
                                  value={formik.values.cheque_number}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                    onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Check Number"  />
                                  
                              </div>
                              <small>
                                {backendErrors.cheque_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.cheque_number}
                                    </span>
                                  )}
                              </small>
                            </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                              <label> Date</label>
                              <input
                                type="date"
                                name="date"
                                value={formik.values.date}
                                className= "form-input form-control datetimepicker"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                  onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date}
                                    </span>
                                  )}
                              </small>
                            </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                              <label>Amount</label>
                              
                              <div className="input-group">
                                  <input
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="amount"
                                  value={formik.values.amount}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                    onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Amount" aria-label="Amount" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">dh</span>
                                  </div>
                              </div>
                              <small>
                                {backendErrors.amount && (
                                    <span className="form-error mt-1">
                                      {backendErrors.amount}
                                    </span>
                                  )}
                              </small>
                            </div>
                        </div>



                          <div className="col-md-6">
                            <div className="form-group status">
                                <label>Select Cheque Status</label>
                                <Select
                                  className="w-100"
                                  value={statusOptions.find(option => option.value == formik.values.cheque_status) || null} // Ensure correct format
                                  name="cheque_status"
                                  //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                  onChange={(selectedOption) => {
                                    handleSelectChange("cheque_status", selectedOption);
                                   customHandleCollection(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={statusOptions}
                                  placeholder="Select"   

                                  // value={formik.values.cheque_status}
                                  // name="cheque_status"
                                  // data={statusOptions}
                                  // className= "w-100"
                                  // onChange={(e) => {
                                  //   formik.handleChange(e);
                                  //   customHandleInput(e);
                                  //   customHandleCollection(e);

                                  // }}
                                  //   onBlur={formik.handleBlur}
                                  // options={{
                                  //   placeholder: "Select Cheque Status",
                                  // }}
                                />
                                <small>
                                  {backendErrors.cheque_status && (
                                      <span className="form-error mt-1">
                                        {backendErrors.cheque_status}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group status">
                                <label>Select Expense Type</label>
                                <Select
                                   className="w-100"
                                   value={extypes.find(option => option.value == formik.values.expense_type) || null} // Ensure correct format
                                   name="expense_type"
                                   //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                   onChange={(selectedOption) => {
                                     handleSelectChange("expense_type", selectedOption);
                                    //customHandleCollection(selectedOption);
                                   }}
                                   onBlur={formik.handleBlur}
                                   options={extypes}
                                   placeholder="Select" 
                                 // value={formik.values.expense_type}
                                  // name="expense_type"
                                  // data={extypes}
                                  // className={
                                  //   backendErrors.expense_type
                                  //     ? "w-100 input-error"
                                  //     : "w-100"
                                  // }
                                  // onChange={(e) => {
                                  //   formik.handleChange(e);
                                  //   customHandleInput(e);
                                  //   //customHandleCollection(e);

                                  // }}
                                  //   onBlur={formik.handleBlur}
                                  // options={{
                                  //   placeholder: "Select Expense Type",
                                  // }}
                                />
                                <small>
                                  {backendErrors.expense_type && (
                                      <span className="form-error mt-1">
                                        {backendErrors.expense_type}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>
                          <div className="col-md-6 check-collection-date-section"  
                          style={{ display: value.cheque_status === 1 ? 'block' : 'none' }}>
                          <div className="form-group">
                              <label>Cheque Collection Date</label>
                              <input
                                type="date"
                                name="cheque_collection_date"
                                value={formik.values.cheque_collection_date}
                                className="form-input form-control datetimepicker"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                  onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.cheque_collection_date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.cheque_collection_date}
                                    </span>
                                  )}
                              </small>
                            </div>
                        </div>


                          
                        <div className="col-md-12">
                        <div className="form-group">
                              <label>Cheque Designation</label>
                            
                              <input
                                type="text"
                                name="cheque_designation"
                                value={formik.values.cheque_designation}
                                className= "form-input form-control"
                               // onChange={formik.handleChange}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                              />
                              <small>
                                {backendErrors.cheque_designation && (
                                    <span className="form-error mt-1">
                                      {backendErrors.cheque_designation}
                                    </span>
                                  )}
                              </small>
                            </div>
                        </div>



                        </div>



                      
                        <div className="text-end mt-4">
                          <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                          Update Cheque FollowUp
                          </button>
                        </div>
                      </form>
                    
                      )}
                     </FormikProvider>
                 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ChequeFollowUpEdit;
